import { Pipe, PipeTransform } from '@angular/core';
import { getNestedPropertyValue } from '../utils';

/**
 * Pipe to filter an array of objects by a property value.
 *
 * @example
 * <div *ngFor="let user of users | searchBy:searchTerm:'address.city'">
 */
@Pipe({
  name: 'searchBy',
})
export class SearchByPipe implements PipeTransform {
  public transform(
    items: Record<string | number | symbol, unknown>[],
    searchTerm: string,
    property: string
  ): Record<string | number | symbol, unknown>[] {
    if (!items || !searchTerm || !property) {
      return items;
    }

    return items.filter((item) => {
      const value = getNestedPropertyValue(item, property);
      return (
        value &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
  }
}
